import { render, staticRenderFns } from "./ncNpChart.vue?vue&type=template&id=472c50b2&scoped=true"
import script from "./ncNpChart.vue?vue&type=script&lang=js"
export * from "./ncNpChart.vue?vue&type=script&lang=js"
import style0 from "./ncNpChart.vue?vue&type=style&index=0&id=472c50b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472c50b2",
  null
  
)

export default component.exports